// This file was generated by lezer-generator. You probably shouldn't edit it.
import { LRParser } from "@lezer/lr";
export const datatableFormulaParser = LRParser.deserialize({
  version: 14,
  states:
    "#`OVQPOOQbQPOOOVQPO'#C`OOQO'#Cj'#CjOOQO'#Ca'#CaOOQO'#Cb'#CbOOQO'#Cc'#CcOOQO'#Cd'#CdOVQPO,58zOVQPO,58zObQPO,58zOOQO1G.f1G.fOpQPO1G.fOVQPO1G.fOVQPO1G.fO!UQPO7+$QO!gQPO7+$QOOQO<<Gl<<Gl",
  stateData:
    "!x~O]OS~OQRORROXQO~O_SO`TOaUObVO~O_SO`TOZSiaSibSiYSi~OYaO_Si`SiaSibSi~OYaO_SO`TOaSibSi~O",
  goto: "!Y_PPPP`hhppPPPPPv]ROQWX]^UWP[`R]YQXPR^YQPOQYQQZWQ[XQ_]R`^",
  nodeNames:
    "⚠ Formula Number Variable NumericExpression MultiplicationOperator DivisionOperator AdditionOperator SubtractionOperator OpeningBracket ClosingBracket",
  maxTerm: 18,
  skippedNodes: [0],
  repeatNodeCount: 0,
  tokenData:
    "&j~RbX^!Zpq!Ztu#Oxy$iyz$nz{$s{|$x}!O$}!P!Q%S!Q![%X#y#z!Z$f$g!Z#BY#BZ!Z$IS$I_!Z$I|$JO!Z$JT$JU!Z$KV$KW!Z&FU&FV!Z~!`Y]~X^!Zpq!Z#y#z!Z$f$g!Z#BY#BZ!Z$IS$I_!Z$I|$JO!Z$JT$JU!Z$KV$KW!Z&FU&FV!Z~#RR!Q![#[!c!}$Y#T#o$Y~#_S!Q![#[!c!}#k#R#S#|#T#o#k~#pSR~!Q![#k!c!}#k#R#S#|#T#o#k~$PR!Q![#k!c!}#k#T#o#k~$]S!Q![#k!c!}#k#R#S#|#T#o#k~$nOX~~$sOY~~$xO_~~$}Oa~~%SOb~~%XO`~~%^SQ~!O!P%j!Q![%X!g!h&O#X#Y&O~%mP!Q![%p~%uRQ~!Q![%p!g!h&O#X#Y&O~&RR{|&[}!O&[!Q![&b~&_P!Q![&b~&gPQ~!Q![&b",
  tokenizers: [0],
  topRules: { Formula: [0, 1] },
  tokenPrec: 0,
  termNames: {
    "0": "⚠",
    "1": "@top",
    "2": "Number",
    "3": "Variable",
    "4": "NumericExpression",
    "5": "MultiplicationOperator",
    "6": "DivisionOperator",
    "7": "AdditionOperator",
    "8": "SubtractionOperator",
    "9": "OpeningBracket",
    "10": "ClosingBracket",
    "11": "␄",
    "12": "%mainskip",
    "13": "space",
    "14": "expression",
    "15": '"*"',
    "16": '"/"',
    "17": '"+"',
    "18": '"-"',
  },
});
